var exports = {
  "p": "xcc377c0b--44ba32--list",
};

module.exports = exports;
